import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, vModelSelect as _vModelSelect, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wage-layout home-wage-layout" }
const _hoisted_2 = { class: "wage-sidebar wage-sidebar--facility home-wage-sidebar member-remote-sidebar" }
const _hoisted_3 = { class: "sidebar-scroll" }
const _hoisted_4 = { class: "sidebar-top" }
const _hoisted_5 = { class: "sidebar-ym-selector" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "ym-display" }
const _hoisted_8 = { class: "ym-value" }
const _hoisted_9 = ["value", "aria-label", "disabled"]
const _hoisted_10 = { class: "ym-magam-slot" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled", "title"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "wage-magam-guide wage-magam-guide--tip"
}
const _hoisted_15 = { class: "sidebar-settings" }
const _hoisted_16 = { class: "setting-item" }
const _hoisted_17 = { class: "setting-item" }
const _hoisted_18 = { class: "setting-rate-input" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "sidebar-savings-btn__text" }
const _hoisted_22 = {
  key: 0,
  class: "sidebar-savings-btn__value"
}
const _hoisted_23 = {
  key: 1,
  class: "sidebar-savings-btn__sub"
}
const _hoisted_24 = { class: "sidebar-employee-panel" }
const _hoisted_25 = { class: "sidebar-list-header" }
const _hoisted_26 = { class: "list-header-count" }
const _hoisted_27 = { class: "sidebar-search-wrap" }
const _hoisted_28 = { class: "sidebar-search" }
const _hoisted_29 = { class: "search-item" }
const _hoisted_30 = { class: "search-input-wrap" }
const _hoisted_31 = { class: "search-item" }
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "sidebar-list-columns"
}
const _hoisted_34 = { class: "sidebar-employee-list" }
const _hoisted_35 = {
  key: 0,
  class: "sidebar-list-loading"
}
const _hoisted_36 = {
  key: 1,
  class: "sidebar-list-empty"
}
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = { class: "emp-item-main" }
const _hoisted_39 = { class: "emp-item-name" }
const _hoisted_40 = {
  key: 0,
  class: "emp-item-badges"
}
const _hoisted_41 = {
  key: 0,
  class: "emp-badge emp-badge--owner"
}
const _hoisted_42 = {
  key: 1,
  class: "emp-badge emp-badge--join"
}
const _hoisted_43 = {
  key: 2,
  class: "emp-badge emp-badge--leave"
}
const _hoisted_44 = { class: "emp-item-job" }
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = { class: "sidebar-excluded-label" }
const _hoisted_47 = { class: "sidebar-emp-item__select sidebar-emp-item__select--static" }
const _hoisted_48 = { class: "emp-item-main" }
const _hoisted_49 = { class: "emp-item-name" }
const _hoisted_50 = { class: "emp-item-job" }
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = {
  key: 0,
  class: "sidebar-migration-block"
}
const _hoisted_53 = { class: "sidebar-footer-block" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "sidebar-bottom"
}
const _hoisted_56 = { class: "sidebar-tax-info" }
const _hoisted_57 = { class: "tax-info-title-row" }
const _hoisted_58 = { class: "tax-info-title" }
const _hoisted_59 = { class: "tax-info-body" }
const _hoisted_60 = {
  key: 0,
  class: "tax-info-note"
}
const _hoisted_61 = {
  key: 1,
  class: "sidebar-wage-delete"
}
const _hoisted_62 = { class: "sidebar-wage-delete__hint" }
const _hoisted_63 = { class: "wage-main-content home-wage-main" }
const _hoisted_64 = {
  key: 0,
  class: "home-wage-content-shell home-wage-content-shell--list"
}
const _hoisted_65 = { class: "home-wage-toolbar" }
const _hoisted_66 = { class: "toolbar-left" }
const _hoisted_67 = { class: "toolbar-title" }
const _hoisted_68 = { class: "toolbar-count" }
const _hoisted_69 = { class: "toolbar-report-actions" }
const _hoisted_70 = { class: "toolbar-right" }
const _hoisted_71 = { class: "home-wage-table-wrap" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "col-no" }
const _hoisted_75 = { class: "col-name" }
const _hoisted_76 = { class: "name-cell" }
const _hoisted_77 = { class: "name-cell-text" }
const _hoisted_78 = { class: "name-cell-label" }
const _hoisted_79 = {
  key: 0,
  class: "emp-item-badges"
}
const _hoisted_80 = {
  key: 0,
  class: "emp-badge emp-badge--owner"
}
const _hoisted_81 = {
  key: 1,
  class: "emp-badge emp-badge--join"
}
const _hoisted_82 = {
  key: 2,
  class: "emp-badge emp-badge--leave"
}
const _hoisted_83 = { class: "col-wage" }
const _hoisted_84 = { class: "col-wage" }
const _hoisted_85 = { class: "col-wage" }
const _hoisted_86 = {
  key: 1,
  class: "home-wage-content-shell home-wage-content-shell--detail"
}
const _hoisted_87 = { class: "home-wage-toolbar" }
const _hoisted_88 = { class: "toolbar-left" }
const _hoisted_89 = { class: "toolbar-title" }
const _hoisted_90 = { class: "toolbar-name-nav" }
const _hoisted_91 = ["disabled"]
const _hoisted_92 = { class: "toolbar-emp-name" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "toolbar-job" }
const _hoisted_95 = { class: "toolbar-tenure" }
const _hoisted_96 = {
  key: 0,
  class: "toolbar-age"
}
const _hoisted_97 = { class: "toolbar-report-actions" }
const _hoisted_98 = { class: "toolbar-right" }
const _hoisted_99 = { class: "home-wage-tax-rate-edit-dialog" }
const _hoisted_100 = { class: "home-wage-tax-rate-edit-dialog__header" }
const _hoisted_101 = { class: "header-title" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { class: "home-wage-tax-rate-edit-dialog__body" }
const _hoisted_104 = {
  key: 0,
  class: "edit-note"
}
const _hoisted_105 = { class: "edit-label" }
const _hoisted_106 = { class: "edit-input-wrap" }
const _hoisted_107 = ["onUpdate:modelValue", "inputmode", "onBlur"]
const _hoisted_108 = {
  key: 0,
  class: "edit-unit"
}
const _hoisted_109 = { class: "home-wage-tax-rate-edit-dialog__footer" }

import { ref, computed, watch, onMounted, inject, provide, type Ref } from 'vue';
import YmdDateInput from '@/components/common/YmdDateInput.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { commonWageApi, homeWageApi, tokenManager } from '@/services/api';
import CommonWageEditModal from '@/components/wage/common/CommonWageEditModal.vue';
import CommonWageReportMenu from '@/components/wage/common/CommonWageReportMenu.vue';
import WageSlipBroadcastButton from '@/components/wage/common/WageSlipBroadcastButton.vue';
import CommonWageReportExcel from '@/components/wage/common/CommonWageReportExcel.vue';
import CommonWageNontaxCompare from '@/components/wage/common/CommonWageNontaxCompare.vue';
import CommonWageNontaxCompareYearly from '@/components/wage/common/CommonWageNontaxCompareYearly.vue';
// SMS 비활성 — 활성화 시 import 주석 해제
// import CommonWageSmsModal from '@/components/wage/common/CommonWageSmsModal.vue';
// import CommonWageSmsTestModal from '@/components/wage/common/CommonWageSmsTestModal.vue';
import CommonWageTransaction from '@/components/wage/common/CommonWageTransaction.vue';
import CommonWageLaborCostModal from '@/components/wage/common/CommonWageLaborCostModal.vue';
import WageExcelMigrationModal from '@/components/wage/WageExcelMigrationModal.vue';
import WageSsnMissingModal from '@/components/wage/WageSsnMissingModal.vue';
import WageLedgerConvertModal from '@/components/wage/WageLedgerConvertModal.vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import {
  parseJoinDate,
  calcTenureMonths,
  formatHomeWageRatePercent,
  parseHomeWageRatePercentInput,
  parseHomeWageTaxRateValue,
} from '@/policies/homeWageSettingPolicy';
import {
  getCommonWageLedgerGrossPay,
  getCommonWageLedgerEmployerInsurance,
  getCommonWageLedgerRetirement,
  getCommonWageCenterSaving,
  previewCommonWageRetirement,
  sumCommonWagePayParts,
} from '@/policies/commonWageSettingPolicy';
import {
  bulkSaveCommonWageRows,
  bulkRecalcCopiedDeductions,
  needsCopiedDeductionRecalc,
} from '@/composables/wage/useCommonWageBulkSave';
import { useCommonWageTableDraft } from '@/composables/wage/useCommonWageTableDraft';
import { useWageMemberYearMonth } from '@/composables/useMemberYearMonth';
import {
  useWageMagam,
  getPrevYearMonth,
  formatYearMonthLabel,
  buildMagamBlockButtonTitle,
} from '@/composables/wage/useWageMagam';
import type { IncomeTaxRow } from '@/composables/wage/useCommonWageCalc';
import type { CommonWageListRow, CommonWageListStats, CommonWageTaxRate } from '@/types/commonWage';
import { compareJobThenName, getJobTypeSortRank } from '@/policies/jobTypeSort';
import { rowEmpKey } from '@/utils/empMatchKey';
import { countMonthBusinessDays } from '@/utils/monthBusinessDays';

type MainView = 'list' | 'detail';
type ListSortKey = 'default' | 'name' | 'job' | 'monthlyPay' | 'corpInsurance' | 'retirement';

type TaxRateEditFieldKey =
  | 'rateYeon'
  | 'rateGun'
  | 'rateGo'
  | 'rateJang'
  | 'rateSil'
  | 'rateSan'
  | 'laborCostRate';


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberFacilityWageMonthlySetting',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const memberData = inject<any>('memberData');
const selectedBizGubunRef = inject<Ref<string>>('selectedBizGubun');
const selectedBizGubun = computed(() => selectedBizGubunRef?.value || '');

const isHomeCareBiz = (biz: string) => biz === '방문요양' || biz === '방문목욕';

const memberCode = computed(
  () => (route.params.memberCode as string) || memberData?.value?.m_code || ''
);

const isPopupMode = computed(() => !!route.params.memberCode);

const homeRouteName = computed(() =>
  isPopupMode.value ? 'memberDetailWageMonthlySettingHome' : 'memberWageMonthlySettingHome'
);

const {
  selectedYear,
  selectedMonth,
  changeMonth: rawChangeMonth,
  onMonthPickerChange: rawMonthPickerChange,
  setYearMonth,
} = useWageMemberYearMonth(memberCode);

const yearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

/** 이 연월 마감 조회가 끝났고, 실제로 마감된 경우에만 저장 스냅샷 */
const wageMonthSnapshot = computed(
  () => magamResolvedYearMonth.value === yearMonth.value && isWageMagamClosed.value
);

const {
  isClosed: isWageMagamClosed,
  resolvedYearMonth: magamResolvedYearMonth,
  loading: wageMagamLoading,
  closing: wageMagamClosing,
  releasing: wageMagamReleasing,
  isReadOnly: isWageReadOnly,
  ssnMissingCount,
  joinMissingCount,
  ssnMissingBlocksClose,
  closeMagam: closeWageMagam,
  releaseMagam: releaseWageMagam,
  loadStatus: loadWageMagamStatus,
} = useWageMagam({
  memberCode,
  yearMonth,
  bizGubun: selectedBizGubun,
  hasPrevWageData: async () => {
    const prevYm = getPrevYearMonth(yearMonth.value);
    if (!memberCode.value || !prevYm || prevYm.length < 6) return false;
    try {
      const prevYear = parseInt(prevYm.slice(0, 4), 10);
      const prevMonth = parseInt(prevYm.slice(4, 6), 10);
      const res = await commonWageApi.getList(memberCode.value, {
        year: prevYear,
        month: prevMonth,
        bizGubun: selectedBizGubun.value || undefined,
      });
      const rows = res.data?.data;
      return (
        Array.isArray(rows) &&
        rows.some(
          (r: any) =>
            Number(r?.cwhd_list_excluded) !== 1 &&
            (r.cwhd_idx || r.cwhd_wage_total != null)
        )
      );
    } catch {
      return false;
    }
  },
});

const ssnMissingModalOpen = ref(false);

const onCloseWageMagamClick = async () => {
  if (ssnMissingBlocksClose.value) {
    ssnMissingModalOpen.value = true;
    return;
  }
  await closeWageMagam();
};

const onSsnMissingSaved = async () => {
  await loadWageMagamStatus();
};

const onSsnMissingContinueMagam = async () => {
  ssnMissingModalOpen.value = false;
  await loadWageMagamStatus();
  if (ssnMissingBlocksClose.value) {
    ssnMissingModalOpen.value = true;
    return;
  }
  await closeWageMagam();
};

const magamReadyButtonTitle = computed(() =>
  buildMagamBlockButtonTitle(ssnMissingCount.value, joinMissingCount.value)
);

// ═══════════════════════════════════════════════════════════════════════
// ★★★ 저장하지 않은 변경사항 추적 (Unsaved Changes Guard) ★★★
// ═══════════════════════════════════════════════════════════════════════
/** 현재 상세 화면에서 저장하지 않은 변경사항이 있는지 */
const hasUnsavedChanges = ref(false);

/** 저장 완료 또는 초기화 시 호출 — dirty 플래그 해제 */
const clearDirty = () => {
  hasUnsavedChanges.value = false;
};

/** 저장하지 않은 변경사항 확인 — true면 진행, false면 취소 */
const confirmUnsavedChanges = (): boolean => {
  if (!hasUnsavedChanges.value) return true;
  return window.confirm(
    '저장하지 않은 변경사항이 있습니다.\n\n저장하지 않고 계속 진행하시겠습니까?'
  );
};

/** ★ 월 변경 래핑 — 저장하지 않은 변경사항 확인 */
const changeMonth = (delta: number) => {
  if (!confirmUnsavedChanges()) return;
  clearDirty();
  rawChangeMonth(delta);
};

/** ★ 월 선택기 래핑 — 저장하지 않은 변경사항 확인 */
const onMonthPickerChange = (event: Event) => {
  if (!confirmUnsavedChanges()) {
    const input = event.target as HTMLInputElement;
    input.value = `${selectedYear.value}-${String(selectedMonth.value).padStart(2, '0')}`;
    return;
  }
  clearDirty();
  rawMonthPickerChange(event);
};
const payDate = ref('');
const savingMonthSettings = ref(false);
const sanRate = ref(0.0068);
const sanRateDisplay = ref('0.68');
const formatSanRateDisplay = (value: number | string): string =>
  formatHomeWageRatePercent(value, { withSuffix: false });
const listLoading = ref(false);
const bulkLoading = ref(false);
const mainView = ref<MainView>('list');
const selectedRow = ref<CommonWageListRow | null>(null);

/** 변경사항 발생 시 호출 — dirty 플래그 설정 (상세 화면에서만) */
const markDirty = () => {
  if (mainView.value === 'detail' && selectedRow.value) {
    hasUnsavedChanges.value = true;
  }
};
const searchFiltersExpanded = ref(false);
const taxRatePanelExpanded = ref(false);
const filterJobType = ref('');
const sortKey = ref<ListSortKey>('default');
const sortOrder = ref<'asc' | 'desc'>('asc');
const wageReportRef = ref<InstanceType<typeof CommonWageReportExcel> | null>(null);
const nontaxCompareRef = ref<InstanceType<typeof CommonWageNontaxCompare> | null>(null);
const nontaxCompareYearlyRef = ref<InstanceType<typeof CommonWageNontaxCompareYearly> | null>(null);
// const smsModalRef = ref<InstanceType<typeof CommonWageSmsModal> | null>(null);
// const smsTestModalRef = ref<InstanceType<typeof CommonWageSmsTestModal> | null>(null);
const transactionRef = ref<InstanceType<typeof CommonWageTransaction> | null>(null);
const searchText = ref('');
const savingAll = ref(false);
const savingAllProgress = ref({ current: 0, total: 0 });
const savingDetail = ref(false);
const importingPrevMonth = ref(false);
const wageEditModalRef = ref<InstanceType<typeof CommonWageEditModal> | null>(null);
const incomeTaxTable = ref<IncomeTaxRow[]>([]);

/** 자동계산 — 항상 ON (계산 버튼 없이 자동으로 계산됨) */
const autoCalcMode = ref(true);

const roleLevel = computed(() => Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0));
const isAdmin = computed(() => roleLevel.value >= 60);
const canEditTaxRate = computed(() => roleLevel.value >= 60);
/** 기본급 산출 방식 토글 — 관리자 권한(80) 이상 전용 */
const canUseBasicCalcMode = computed(() => roleLevel.value >= 80);
/** 매니저(50+)·직원(40+) 툴팁 — 기관회원(고객) 로그인 시 숨김. 실비변상 등은 member-visible */
const showTooltips = computed(() => roleLevel.value >= 40);
provide('showWageTooltips', showTooltips);
const showMigrationModal = ref(false);
const showLedgerConvertModal = ref(false);
const laborCostModalRef = ref<InstanceType<typeof CommonWageLaborCostModal> | null>(null);
const loadingLaborCostModal = ref(false);
const showTaxRateEditModal = ref(false);
const savingTaxRate = ref(false);
const taxRateEditTargetYear = ref(new Date().getFullYear());

const taxRateEditFields: { key: TaxRateEditFieldKey; label: string; unit: string; isLaborRate?: boolean }[] = [
  { key: 'rateYeon', label: '국민연금', unit: '%' },
  { key: 'rateGun', label: '건강보험', unit: '%' },
  { key: 'rateGo', label: '고용보험', unit: '%' },
  { key: 'rateJang', label: '장기요양', unit: '%' },
  { key: 'rateSil', label: '실업급여', unit: '%' },
  { key: 'rateSan', label: '산재보험', unit: '%' },
  { key: 'laborCostRate', label: '인건비율', unit: '%', isLaborRate: true },
];

const taxRateEditForm = ref<Record<TaxRateEditFieldKey, string>>({
  rateYeon: '',
  rateGun: '',
  rateGo: '',
  rateJang: '',
  rateSil: '',
  rateSan: '',
  laborCostRate: '',
});

const migrationYearMonth = computed(
  () => `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`
);

const onMigrationImported = async () => {
  await loadWageList();
};

/** 회계처리용 임금대장 — 매니저(50+) 이상, 기관회원 제외 */
const canViewAccountingReport = computed(() => store.getters.canViewAccountingWageReport);

const memberDisplayName = computed(
  () => memberData?.value?.m_name || memberData?.m_name || ''
);

const wageRows = ref<CommonWageListRow[]>([]);
/** 빠른 월 이동 시 stale API 응답 무시 */
const monthDataLoadSeq = ref(0);
const stats = ref<CommonWageListStats>({
  totalCount: 0,
  totalWage: 0,
  totalLDeduction: 0,
  totalCDeduction: 0,
});
const taxRateInfo = ref<CommonWageTaxRate | null>(null);
const taxRateFallback = ref(false);

const minHourlyWageRef = computed(() => taxRateInfo.value?.minHourlyWage);

const holidayDates = ref<string[]>([]);
const holidaysReady = ref(false);
let holidayLoadSeq = 0;

const loadHolidayDates = async (year: number) => {
  const seq = ++holidayLoadSeq;
  holidaysReady.value = false;
  try {
    const res = await homeWageApi.getHolidays({ year });
    if (seq !== holidayLoadSeq) return;
    const dates: string[] = [];
    for (const item of res.data?.data || []) {
      const date = String(item?.date || '').substring(0, 10);
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) dates.push(date);
    }
    holidayDates.value = dates;
  } catch (error) {
    if (seq !== holidayLoadSeq) return;
    console.error('공휴일 조회 오류:', error);
    holidayDates.value = [];
  } finally {
    if (seq === holidayLoadSeq) holidaysReady.value = true;
  }
};

/** 근무일수 미입력 시: 그 달의 토·일·공휴일을 뺀 일수. 조회 전에는 null */
const defaultWorkDays = computed<number | null>(() => {
  if (!holidaysReady.value) return null;
  return countMonthBusinessDays(selectedYear.value, selectedMonth.value, holidayDates.value);
});

watch(selectedYear, (year) => {
  void loadHolidayDates(year);
}, { immediate: true });

const tableDraft = useCommonWageTableDraft({
  minHourlyWage: minHourlyWageRef,
  taxRateInfo,
  incomeTaxTable,
  year: selectedYear,
  month: selectedMonth,
  mCode: memberCode,
  bizGubun: selectedBizGubun,
  defaultWorkDays,
});

const effectiveTaxRateInfo = computed<CommonWageTaxRate | null>(() => {
  if (!taxRateInfo.value) return null;
  if (sanRate.value > 0) {
    return { ...taxRateInfo.value, rateSan: sanRate.value };
  }
  return taxRateInfo.value;
});

const taxRate = computed(() => ({
  tr_yeon: Number(taxRateInfo.value?.rateYeon) || 0.045,
  tr_gun: Number(taxRateInfo.value?.rateGun) || 0.03545,
  tr_jang: Number(taxRateInfo.value?.rateJang) || 0.1295,
  tr_go: Number(taxRateInfo.value?.rateGo) || 0.009,
  tr_sil: Number(taxRateInfo.value?.rateSil) || 0.009,
  tr_san: sanRate.value > 0 ? sanRate.value : Number(taxRateInfo.value?.rateSan) || 0.007,
}));

const taxRateDisplayRows = computed(() => {
  const t = taxRateInfo.value;
  if (!t) return [];
  const san = sanRate.value > 0 ? sanRate.value : parseHomeWageTaxRateValue(t.rateSan, 0.007);
  return [
    { label: '최저시급', value: `${formatNum(t.minHourlyWage)}원` },
    { label: '국민연금', value: formatHomeWageRatePercent(t.rateYeon) },
    { label: '건강보험', value: formatHomeWageRatePercent(t.rateGun) },
    { label: '고용보험', value: formatHomeWageRatePercent(t.rateGo) },
    { label: '장기요양', value: formatHomeWageRatePercent(t.rateJang) },
    { label: '실업급여', value: formatHomeWageRatePercent(t.rateSil) },
    { label: '산재보험', value: formatHomeWageRatePercent(san) },
    { label: '인건비율', value: formatHomeWageRatePercent(t.laborCostRate, { scaleFromDecimal: false }) },
  ];
});

const sidebarMonthSaving = computed(() => {
  if (savedWageRows.value.length === 0) return null;
  return savedWageRows.value.reduce((sum, row) => sum + getCommonWageCenterSaving(row), 0);
});

const jobTypeOptions = computed(() => {
  const jobs = new Set<string>();
  wageRows.value.forEach((row) => {
    if (!isListExcluded(row) && row.ce_position) jobs.add(row.ce_position);
  });
  return Array.from(jobs).sort((a, b) => compareJobThenName(a, '', b, ''));
});

/** 마감이 확인된 달만 저장 퇴직금. 그 외에는 한도 중식비 기준 */
const retirementAmountForList = (row: CommonWageListRow) => {
  if (wageMonthSnapshot.value || !row.cwhd_idx) {
    return getCommonWageLedgerRetirement(row);
  }
  return previewCommonWageRetirement(row, selectedYear.value, selectedMonth.value);
};

const getListSortValue = (row: CommonWageListRow, key: 'monthlyPay' | 'corpInsurance' | 'retirement') => {
  if (key === 'monthlyPay') return getCommonWageLedgerGrossPay(row);
  if (key === 'corpInsurance') return getCommonWageLedgerEmployerInsurance(row);
  return retirementAmountForList(row);
};

const getJobRank = (job: string): number => getJobTypeSortRank(job);

const isListExcluded = (row: CommonWageListRow) =>
  Number(row.cwhd_list_excluded) === 1 || row.cwhd_list_excluded === true;

const filterWageRowsBySearch = (list: CommonWageListRow[]) => {
  let next = [...list];
  const q = searchText.value.trim().toLowerCase();
  if (q) {
    next = next.filter((row) => row.ce_name?.toLowerCase().includes(q));
  }
  if (filterJobType.value) {
    next = next.filter((row) => row.ce_position === filterJobType.value);
  }
  return next;
};

const sortedEmployees = computed(() => {
  let list = filterWageRowsBySearch(wageRows.value.filter((row) => !isListExcluded(row)));

  list.sort((a, b) => {
    // 대표자는 항상 맨 위 (직종/정렬 조건과 관계없이)
    const ownerA = a.cwhd_is_owner === 1;
    const ownerB = b.cwhd_is_owner === 1;
    if (ownerA && !ownerB) return -1;
    if (!ownerA && ownerB) return 1;

    const nameA = a.ce_name || '';
    const nameB = b.ce_name || '';
    const jobA = a.ce_position || '';
    const jobB = b.ce_position || '';

    if (sortKey.value === 'name') {
      const cmp = nameA.localeCompare(nameB, 'ko');
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    if (sortKey.value === 'job') {
      const cmp = jobA.localeCompare(jobB, 'ko');
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    if (sortKey.value === 'monthlyPay') {
      const cmp = getListSortValue(a, 'monthlyPay') - getListSortValue(b, 'monthlyPay');
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    if (sortKey.value === 'corpInsurance') {
      const cmp = getListSortValue(a, 'corpInsurance') - getListSortValue(b, 'corpInsurance');
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    if (sortKey.value === 'retirement') {
      const cmp = getListSortValue(a, 'retirement') - getListSortValue(b, 'retirement');
      return sortOrder.value === 'asc' ? cmp : -cmp;
    }
    const rankA = getJobRank(a.ce_position || '');
    const rankB = getJobRank(b.ce_position || '');
    if (rankA !== rankB) return rankA - rankB;
    return compareJobThenName(jobA, nameA, jobB, nameB);
  });

  return list;
});

const excludedEmployees = computed(() => {
  const list = filterWageRowsBySearch(wageRows.value.filter((row) => isListExcluded(row)));
  list.sort((a, b) =>
    compareJobThenName(a.ce_position || '', a.ce_name || '', b.ce_position || '', b.ce_name || '')
  );
  return list;
});

const filteredRows = computed(() => sortedEmployees.value);

/** 저장된 행 — 임금합계 필드가 0이어도 항목 합이 있으면 대장 대상 (제거된 사원 제외) */
const savedWageRows = computed(() =>
  wageRows.value.filter(
    (row) =>
      !isListExcluded(row) &&
      row.cwhd_idx != null &&
      (Number(row.cwhd_wage_total) > 0 || sumCommonWagePayParts(row) > 0)
  )
);

const toggleSort = (key: Exclude<ListSortKey, 'default'>) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }
};

const getSortIcon = (key: string) => {
  if (sortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return sortOrder.value === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down';
};

const avatarColors = [
  '#1e3a5f', '#2e7d32', '#c62828', '#f57c00', '#6a1b9a',
  '#00838f', '#4527a0', '#ad1457', '#00695c', '#bf360c',
];

const getAvatarColor = (name?: string | null) => {
  if (!name || name === '-') return '#90a4ae';
  return avatarColors[name.charCodeAt(0) % avatarColors.length];
};

const getInitial = (name?: string | null) => (name && name !== '-' ? name.charAt(0) : '?');

const formatListWageAmount = (
  row: CommonWageListRow,
  field: 'monthlyPay' | 'corpInsurance' | 'retirement'
) => {
  const val = getListSortValue(row, field);
  return val > 0 ? formatNum(val) : '-';
};

const isSelectedEmployee = (row: CommonWageListRow) =>
  selectedRow.value != null && rowEmpKey(selectedRow.value) === rowEmpKey(row);

const selectEmployee = (row: CommonWageListRow) => {
  // ★ 저장하지 않은 변경사항 확인
  if (!confirmUnsavedChanges()) return;
  clearDirty();
  
  const key = rowEmpKey(row);
  selectedRow.value = wageRows.value.find((r) => rowEmpKey(r) === key) ?? row;
  mainView.value = 'detail';
};

const showAllList = () => {
  // ★ 저장하지 않은 변경사항 확인
  if (!confirmUnsavedChanges()) return;
  clearDirty();
  
  mainView.value = 'list';
  selectedRow.value = null;
};

const selectedEmployeeIndex = computed(() => {
  if (!selectedRow.value) return -1;
  const key = rowEmpKey(selectedRow.value);
  return sortedEmployees.value.findIndex((row) => rowEmpKey(row) === key);
});

const canNavigatePrevEmployee = computed(() => selectedEmployeeIndex.value > 0);

const canNavigateNextEmployee = computed(() => {
  const idx = selectedEmployeeIndex.value;
  return idx >= 0 && idx < sortedEmployees.value.length - 1;
});

const isEmployeeNavDisabled = computed(
  () => listLoading.value || bulkLoading.value || savingDetail.value || importingPrevMonth.value
);

const navigatePrevEmployee = () => {
  const idx = selectedEmployeeIndex.value;
  if (idx <= 0 || isEmployeeNavDisabled.value) return;
  selectEmployee(sortedEmployees.value[idx - 1]);
};

const navigateNextEmployee = () => {
  const idx = selectedEmployeeIndex.value;
  if (idx < 0 || idx >= sortedEmployees.value.length - 1 || isEmployeeNavDisabled.value) return;
  selectEmployee(sortedEmployees.value[idx + 1]);
};

const savedWageCount = computed(() => savedWageRows.value.length);

const selectedYm = computed(
  () => `${selectedYear.value}-${String(selectedMonth.value).padStart(2, '0')}`
);

/** 입사일·퇴사일 → YYYY-MM (DB Date·ISO·YYYY.MM.DD 등 통일) */
const dateToYm = (dateVal: string | Date | null | undefined): string | null => {
  if (dateVal == null || dateVal === '') return null;
  let head: string;
  if (dateVal instanceof Date) {
    if (Number.isNaN(dateVal.getTime())) return null;
    head = `${dateVal.getFullYear()}-${String(dateVal.getMonth() + 1).padStart(2, '0')}-${String(dateVal.getDate()).padStart(2, '0')}`;
  } else {
    head = String(dateVal).trim().substring(0, 10).replace(/\./g, '-').replace(/\//g, '-');
  }
  const m = head.match(/^(\d{4})-(\d{1,2})/);
  if (!m) return null;
  return `${m[1]}-${String(m[2]).padStart(2, '0')}`;
};

const isJoinMonth = (item: CommonWageListRow) => dateToYm(item.ce_join_date) === selectedYm.value;

const isLeaveMonth = (item: CommonWageListRow) => dateToYm(item.ce_leave_date) === selectedYm.value;

/** 선택 연월 말일 기준 근로개월수 */
const getEmpTenureMonths = (row: CommonWageListRow | null): number | null => {
  if (!row) return null;
  const raw = row.ce_join_date || row.cwhd_join_date;
  const join = parseJoinDate(raw as string);
  if (!join) return null;
  return calcTenureMonths(join, selectedYear.value, selectedMonth.value);
};

/** 툴바 칩용 근무 개월수 표시 */
const formatEmpTenureChip = (row: CommonWageListRow | null): string => {
  const months = getEmpTenureMonths(row);
  if (months === null) return '-';
  return `${months}개월차`;
};

/** 만나이 계산 */
const getEmpAge = (row: CommonWageListRow | null): number | null => {
  if (!row) return null;
  const birth = row.ce_birth_date || row.cwhd_birth;
  if (!birth) return null;
  const birthDate = new Date(birth);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age >= 0 ? age : null;
};

/** 만나이 칩 표시 */
const formatEmpAgeChip = (row: CommonWageListRow | null): string | null => {
  const age = getEmpAge(row);
  if (age === null) return null;
  return `만${age}세`;
};

const formatNum = (val: number | null | undefined) => {
  const num = Number(val) || 0;
  return num.toLocaleString('ko-KR');
};

const getDefaultPayDate = () => {
  let payYear = selectedYear.value;
  let payMonth = selectedMonth.value + 1;
  if (payMonth > 12) {
    payMonth = 1;
    payYear += 1;
  }
  return `${payYear}-${String(payMonth).padStart(2, '0')}-10`;
};

const redirectIfHomeCare = () => {
  if (!selectedBizGubun.value || !isHomeCareBiz(selectedBizGubun.value)) return;
  const params = isPopupMode.value ? { memberCode: memberCode.value } : undefined;
  router.replace({ name: homeRouteName.value, params });
};

const resolveSanRate = (data: { sanRate?: number | null; cwp_san_rate?: number | null } | null | undefined) => {
  const raw = data?.sanRate ?? data?.cwp_san_rate;
  return raw != null && Number(raw) > 0 ? Number(raw) : null;
};

const applyMonthlySetting = (data: { payDate?: string | null; sanRate?: number | null } | null) => {
  if (data?.payDate) {
    payDate.value = String(data.payDate).substring(0, 10);
  } else {
    payDate.value = getDefaultPayDate();
  }
  const rate = resolveSanRate(data);
  if (rate != null) {
    sanRate.value = rate;
    sanRateDisplay.value = formatSanRateDisplay(rate);
  }
};

const fetchPreviousSanRate = async () => {
  if (!memberCode.value) {
    sanRate.value = 0.0068;
    sanRateDisplay.value = '0.68';
    return;
  }
  for (let i = 1; i <= 12; i++) {
    let targetYear = selectedYear.value;
    let targetMonth = selectedMonth.value - i;
    if (targetMonth <= 0) {
      targetYear -= 1;
      targetMonth += 12;
    }
    try {
      const response = await commonWageApi.getMonthlySetting(
        memberCode.value,
        targetYear,
        targetMonth,
        selectedBizGubun.value
      );
      const rate = resolveSanRate(response.data?.data);
      if (response.data?.success && rate != null) {
        sanRate.value = rate;
        sanRateDisplay.value = formatSanRateDisplay(rate);
        return;
      }
    } catch {
      // continue
    }
  }
  sanRate.value = 0.0068;
  sanRateDisplay.value = '0.68';
};

const loadMonthlySetting = async () => {
  if (!memberCode.value) return;
  try {
    const response = await commonWageApi.getMonthlySetting(
      memberCode.value,
      selectedYear.value,
      selectedMonth.value,
      selectedBizGubun.value
    );
    const data = response.data?.data;
    if (response.data?.success && data) {
      applyMonthlySetting(data);
      if (resolveSanRate(data) == null) {
        await fetchPreviousSanRate();
      }
    } else {
      payDate.value = getDefaultPayDate();
      await fetchPreviousSanRate();
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    const status = error.response?.status || '';
    alert(`월별 설정 조회 실패: ${message}${status ? ` (${status})` : ''}`);
    payDate.value = getDefaultPayDate();
    await fetchPreviousSanRate();
  }
};

const restoreDetailEmployee = (empKey: string | null) => {
  if (!empKey || mainView.value !== 'detail') return;
  selectedRow.value = wageRows.value.find((row) => rowEmpKey(row) === empKey) || null;
  if (!selectedRow.value) showAllList();
};

const loadWageList = async (preserveEmpKey?: string | null) => {
  if (!memberCode.value) return;
  const loadSeq = ++monthDataLoadSeq.value;
  listLoading.value = true;
  tableDraft.clearDrafts();
  try {
    const response = await commonWageApi.getList(memberCode.value, {
      year: selectedYear.value,
      month: selectedMonth.value,
      bizGubun: selectedBizGubun.value,
    });
    if (loadSeq !== monthDataLoadSeq.value) return;
    if (!response.data?.success) {
      throw new Error(response.data?.message || '목록 조회 실패');
    }
    wageRows.value = response.data.data || [];
    stats.value = response.data.stats || {
      totalCount: wageRows.value.length,
      totalWage: 0,
      totalLDeduction: 0,
      totalCDeduction: 0,
    };
  } catch (error: any) {
    if (loadSeq !== monthDataLoadSeq.value) return;
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    const status = error.response?.status || '';
    alert(`임금 목록 조회 실패: ${message}${status ? ` (${status})` : ''}`);
    wageRows.value = [];
    stats.value = { totalCount: 0, totalWage: 0, totalLDeduction: 0, totalCDeduction: 0 };
  } finally {
    if (loadSeq !== monthDataLoadSeq.value) return;
    if (preserveEmpKey) restoreDetailEmployee(preserveEmpKey);
    listLoading.value = false;
  }
};

const loadIncomeTax = async () => {
  const loadSeq = monthDataLoadSeq.value;
  try {
    const res = await commonWageApi.getIncomeTax(selectedYear.value);
    if (loadSeq !== monthDataLoadSeq.value) return;
    if (res.data?.success && Array.isArray(res.data.data)) {
      incomeTaxTable.value = res.data.data.map((row: { income1: number; income2: number; depe_1: number }) => ({
        income1: Number(row.income1),
        income2: Number(row.income2),
        depe_1: Number(row.depe_1),
      }));
    }
  } catch (error: any) {
    console.error('간이세액표 로드 오류:', error);
  }
};

const loadReferenceData = async () => {
  const loadSeq = monthDataLoadSeq.value;
  try {
    const taxRes = await commonWageApi.getTaxRate(selectedYear.value);
    if (loadSeq !== monthDataLoadSeq.value) return;
    if (taxRes.data?.success && taxRes.data.data) {
      taxRateInfo.value = taxRes.data.data;
      taxRateFallback.value = !!taxRes.data.fallback;
    }
    void loadIncomeTax();
  } catch (error: any) {
    if (loadSeq !== monthDataLoadSeq.value) return;
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`세율 조회 실패: ${message}`);
  }
};

const loadPageData = async (preserveEmpKey?: string | null) => {
  if (!memberCode.value || isHomeCareBiz(selectedBizGubun.value)) return;
  await Promise.all([
    loadMonthlySetting(),
    loadWageList(preserveEmpKey),
    loadReferenceData(),
  ]);
};

const saveMonthSettingsInternal = async () => {
  if (!memberCode.value) return;
  const parsed = parseHomeWageRatePercentInput(sanRateDisplay.value);
  if (parsed == null) {
    throw new Error('산재요율을 확인해 주세요.');
  }
  sanRate.value = parsed;
  sanRateDisplay.value = formatSanRateDisplay(parsed);
  const response = await commonWageApi.saveMonthlySetting({
    mCode: memberCode.value,
    bizGubun: selectedBizGubun.value,
    year: selectedYear.value,
    month: selectedMonth.value,
    payDate: payDate.value || null,
    sanRate: parsed,
  });
  if (!response.data?.success) {
    throw new Error(response.data?.message || '저장 실패');
  }
};

const handleSaveMonthSettings = async () => {
  if (!memberCode.value) return;
  if (isWageMagamClosed.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  savingMonthSettings.value = true;
  try {
    await saveMonthSettingsInternal();
    alert('지급일·산재요율이 저장되었습니다.');
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`지급일·산재요율 저장 실패: ${message}`);
  } finally {
    savingMonthSettings.value = false;
  }
};

const onDetailSaved = async () => {
  const key =
    selectedRow.value && mainView.value === 'detail' ? rowEmpKey(selectedRow.value) : null;
  await loadWageList(key);
};

const removingEmployeeKey = ref<string | null>(null);

/** 저장된 당월 임금이 있는 사원만 목록에서 제거 가능 (전월복사·저장 후) */
const canRemoveEmployeeFromList = (row: CommonWageListRow | null | undefined) =>
  !!row?.cwhd_idx && !isWageReadOnly.value && !isListExcluded(row!);

const removeEmployeeFromList = async (row: CommonWageListRow) => {
  if (!row?.cwhd_idx) {
    alert('아직 저장된 임금이 없는 사원입니다. 전월복사·저장 후에 목록에서 제거할 수 있습니다.');
    return;
  }
  if (isWageReadOnly.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  const name = row.ce_name || '해당 사원';
  if (
    !confirm(
      `${name} 님을 이번 달 임금 사원 목록에서 제거할까요?\n(하단 회색 목록으로 내려가며, 언제든 복원할 수 있습니다.)`
    )
  ) {
    return;
  }

  const key = rowEmpKey(row);
  removingEmployeeKey.value = key;
  try {
    const res = await commonWageApi.delete(row.cwhd_idx);
    if (!res.data?.success) throw new Error(res.data?.message || '삭제 실패');
    clearDirty();
    if (selectedRow.value && rowEmpKey(selectedRow.value) === key) {
      showAllList();
    }
    await loadWageList();
  } catch (error: any) {
    alert(`목록에서 제거 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    removingEmployeeKey.value = null;
  }
};

const restoreEmployeeToList = async (row: CommonWageListRow) => {
  if (!row?.cwhd_idx) return;
  if (isWageReadOnly.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  const key = rowEmpKey(row);
  removingEmployeeKey.value = key;
  try {
    const res = await commonWageApi.restore(row.cwhd_idx);
    if (!res.data?.success) throw new Error(res.data?.message || '복원 실패');
    await loadWageList();
  } catch (error: any) {
    alert(`복원 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    removingEmployeeKey.value = null;
  }
};

const onDetailDeleted = async () => {
  clearDirty();
  showAllList();
  await loadWageList();
};

const importPrevMonthForSelected = async () => {
  if (!selectedRow.value || !wageEditModalRef.value) return;
  importingPrevMonth.value = true;
  try {
    await wageEditModalRef.value.importPrevMonthData();
  } finally {
    importingPrevMonth.value = false;
  }
};

const saveSelectedWage = async () => {
  if (!selectedRow.value || !wageEditModalRef.value) return;
  if (isWageMagamClosed.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  const key = rowEmpKey(selectedRow.value);
  savingDetail.value = true;
  try {
    await wageEditModalRef.value.saveWage();
    await loadWageList(key);
    clearDirty(); // ★ 저장 성공 후 dirty 플래그 해제
  } finally {
    savingDetail.value = false;
  }
};

const onWageReportError = (message: string) => {
  alert(`임금대장 생성 실패: ${message}`);
};

const downloadAccountingReport = () => {
  if (!canViewAccountingReport.value) {
    alert('회계처리용 임금대장은 매니저 이상 권한이 필요합니다.');
    return;
  }
  if (savedWageCount.value === 0) {
    alert('다운로드할 임금 데이터가 없습니다.');
    return;
  }
  wageReportRef.value?.openPreview('accounting');
};

const downloadClientReport = () => {
  if (savedWageCount.value === 0) {
    alert('다운로드할 임금 데이터가 없습니다.');
    return;
  }
  wageReportRef.value?.openPreview('client');
};

const openNontaxCompare = () => {
  if (savedWageCount.value === 0) {
    alert('비과세 분석할 임금 데이터가 없습니다.');
    return;
  }
  nontaxCompareRef.value?.openDialog();
};

const openNontaxCompareYearly = () => {
  if (!memberCode.value) {
    alert('시설 정보를 찾을 수 없습니다.');
    return;
  }
  nontaxCompareYearlyRef.value?.openDialog();
};

const openNontaxSavings = () => {
  if (savedWageCount.value === 0) {
    alert('절감액을 볼 임금 데이터가 없습니다.');
    return;
  }
  nontaxCompareRef.value?.openDialog();
};

const openLaborCostModal = async () => {
  if (!memberCode.value) {
    alert('시설 코드가 없습니다.');
    return;
  }
  loadingLaborCostModal.value = true;
  try {
    await laborCostModalRef.value?.open();
  } finally {
    loadingLaborCostModal.value = false;
  }
};

const openTaxRateEditModal = () => {
  const t = taxRateInfo.value;
  if (!t || !canEditTaxRate.value) return;
  taxRateEditTargetYear.value = selectedYear.value;
  taxRateEditForm.value = {
    rateYeon: formatHomeWageRatePercent(t.rateYeon, { withSuffix: false }),
    rateGun: formatHomeWageRatePercent(t.rateGun, { withSuffix: false }),
    rateGo: formatHomeWageRatePercent(t.rateGo, { withSuffix: false }),
    rateJang: formatHomeWageRatePercent(t.rateJang, { withSuffix: false }),
    rateSil: formatHomeWageRatePercent(t.rateSil, { withSuffix: false }),
    rateSan: formatHomeWageRatePercent(t.rateSan, { withSuffix: false }),
    laborCostRate: formatHomeWageRatePercent(t.laborCostRate, { scaleFromDecimal: false, withSuffix: false }),
  };
  showTaxRateEditModal.value = true;
};

const closeTaxRateEditModal = () => {
  if (savingTaxRate.value) return;
  showTaxRateEditModal.value = false;
};

const onTaxRateEditBlur = (key: TaxRateEditFieldKey) => {
  const field = taxRateEditFields.find((f) => f.key === key);
  if (!field) return;
  const raw = taxRateEditForm.value[key];
  if (field.isLaborRate) {
    const trimmed = String(raw).trim().replace(/%/g, '');
    if (!trimmed) {
      taxRateEditForm.value[key] = '';
      return;
    }
    const n = parseFloat(trimmed);
    taxRateEditForm.value[key] = Number.isFinite(n) ? String(n) : '';
    return;
  }
  const parsed = parseHomeWageRatePercentInput(raw);
  taxRateEditForm.value[key] = parsed != null ? formatHomeWageRatePercent(parsed, { withSuffix: false }) : '';
};

const saveTaxRateEdit = async () => {
  if (savingTaxRate.value) return;
  const f = taxRateEditForm.value;
  const rateKeys: TaxRateEditFieldKey[] = ['rateYeon', 'rateGun', 'rateGo', 'rateJang', 'rateSil', 'rateSan'];
  for (const key of rateKeys) {
    const parsed = parseHomeWageRatePercentInput(f[key]);
    if (parsed == null) {
      alert(`${taxRateEditFields.find((item) => item.key === key)?.label || key} 요율을 확인해 주세요.`);
      return;
    }
  }
  const laborTrimmed = String(f.laborCostRate).trim().replace(/%/g, '');
  const laborCostRate = laborTrimmed ? parseFloat(laborTrimmed) : NaN;
  if (!Number.isFinite(laborCostRate) || laborCostRate < 0) {
    alert('인건비율을 확인해 주세요.');
    return;
  }
  savingTaxRate.value = true;
  try {
    const currentMinHourly = taxRateInfo.value?.minHourlyWage ?? 0;
    const response = await commonWageApi.saveTaxRate(taxRateEditTargetYear.value, {
      minHourlyWage: currentMinHourly,
      rateYeon: parseHomeWageRatePercentInput(f.rateYeon) ?? 0,
      rateGun: parseHomeWageRatePercentInput(f.rateGun) ?? 0,
      rateGo: parseHomeWageRatePercentInput(f.rateGo) ?? 0,
      rateJang: parseHomeWageRatePercentInput(f.rateJang) ?? 0,
      rateSil: parseHomeWageRatePercentInput(f.rateSil) ?? 0,
      rateSan: parseHomeWageRatePercentInput(f.rateSan) ?? 0,
      laborCostRate,
    });
    if (response.data?.success) {
      await loadReferenceData();
      showTaxRateEditModal.value = false;
    } else {
      alert(`세율 저장 실패: ${response.data?.message || '알 수 없는 오류'}`);
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '알 수 없는 오류';
    alert(`세율 저장 실패: ${message}`);
  } finally {
    savingTaxRate.value = false;
  }
};

// SMS 비활성 — 활성화 시 주석 해제
/*
const openSmsModal = () => {
  if (savedWageCount.value === 0) {
    alert('SMS 발송할 임금 데이터가 없습니다.');
    return;
  }
  smsModalRef.value?.openDialog();
};

const openSmsTestModal = () => {
  smsTestModalRef.value?.openDialog();
};
*/

const openTransactionModal = () => {
  transactionRef.value?.openDialog(filteredRows.value.length);
};

const syncUrlYearMonth = () => {
  router.replace({
    query: {
      ...route.query,
      year: String(selectedYear.value),
      month: String(selectedMonth.value),
    },
  });
};

const saveAllData = async () => {
  if (isWageMagamClosed.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  if (!memberCode.value || !taxRateInfo.value) {
    alert('시설 또는 세율 정보를 불러올 수 없습니다.');
    return;
  }
  const allRows = filteredRows.value.filter((r) => r.ce_name);
  const savedItems = allRows.filter((r) => r.cwhd_idx).map((r) => tableDraft.mergeDraftIntoRow(r));
  const unsavedCount = allRows.length - savedItems.length;

  if (allRows.length === 0) {
    alert('저장할 직원이 없습니다.');
    return;
  }

  let confirmMsg = `저장된 임금 ${savedItems.length}건을 저장합니다.\n(요양보호사·조리는 연·야·휴 비과세, 중식비 실비변상 시 회계 중식 채움·그 과세로 공제 재산출 — 중도 입·퇴사는 재직일 비율)`;
  if (savedItems.length === 0) {
    alert('저장할 임금 데이터가 없습니다.\n상세에서 입력 후 「저장」하거나, 이미 저장된 직원이 있어야 합니다.');
    return;
  }
  if (unsavedCount > 0) {
    confirmMsg += `\n\n미저장 ${unsavedCount}명은 상세에서 「저장」해야 반영됩니다.`;
  }
  confirmMsg += '\n\n계속하시겠습니까?';

  if (!confirm(confirmMsg)) {
    return;
  }

  savingAll.value = true;
  savingAllProgress.value = { current: 0, total: Math.max(savedItems.length, 1) };
  bulkLoading.value = true;

  try {
    let result = { successCount: 0, errorCount: 0, skippedCount: 0, errors: [] as string[] };
    if (savedItems.length > 0) {
      result = await bulkSaveCommonWageRows({
        rows: savedItems,
        mCode: memberCode.value,
        bizGubun: selectedBizGubun.value,
        year: selectedYear.value,
        month: selectedMonth.value,
        taxRateInfo: effectiveTaxRateInfo.value || taxRateInfo.value,
        incomeTaxTable: incomeTaxTable.value,
        minHourlyWage: taxRateInfo.value.minHourlyWage,
        defaultWorkDays: defaultWorkDays.value,
        onProgress: (current, total) => {
          savingAllProgress.value = { current, total };
        },
      });
    }

    tableDraft.clearDrafts();

    if (result.errorCount === 0) {
      const skipNote =
        result.skippedCount > 0 ? `\n\n※ 미저장 ${result.skippedCount}명은 건너뜀` : '';
      alert(`저장 완료!\n✓ 임금 갱신: ${result.successCount}명${skipNote}`);
    } else {
      alert(
        `저장 완료 (일부 오류)\n\n✓ 임금 성공: ${result.successCount}명\n✗ 실패: ${result.errorCount}명\n\n` +
          result.errors.slice(0, 5).join('\n') +
          (result.errors.length > 5 ? `\n... 외 ${result.errors.length - 5}건` : '')
      );
    }
    await loadWageList();
  } catch (error: any) {
    alert(`저장 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    savingAll.value = false;
    bulkLoading.value = false;
  }
};

const downloadWageSlip = (options?: { name?: string; birth?: string | null }) => {
  if (!memberCode.value) return;
  if (!options?.name && savedWageCount.value === 0) {
    alert('임금명세서를 생성할 데이터가 없습니다.');
    return;
  }
  const token = tokenManager.getToken();
  if (!token) {
    alert('로그인이 필요합니다.');
    return;
  }
  const params = new URLSearchParams();
  params.append('token', token);
  if (selectedBizGubun.value) {
    params.append('bizGubun', selectedBizGubun.value);
  }
  if (options?.name) {
    params.append('name', options.name);
  }
  if (options?.birth) {
    params.append('birth', options.birth);
  }
  const url = `/api/common-wage/wage-slip-pdf/${memberCode.value}/${selectedYear.value}/${selectedMonth.value}?${params.toString()}`;
  const previewWindow = window.open(url, '_blank');
  if (!previewWindow) {
    alert('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.');
  }
};

const downloadWageSlipForSelected = () => {
  const row = selectedRow.value;
  if (!row?.cwhd_idx) {
    alert('저장된 임금 데이터가 없습니다.');
    return;
  }
  downloadWageSlip({
    name: row.cwhd_name || row.ce_name || '',
    birth: resolveAuthoritativeBirth(row),
  });
};

const handleCopyFromPrev = async () => {
  if (!memberCode.value) return;
  if (isWageMagamClosed.value) {
    alert('마감된 연월은 수정할 수 없습니다.\n마감을 해제한 뒤 다시 시도해 주세요.');
    return;
  }
  if (
    !confirm(
      `${selectedYear.value}년 ${selectedMonth.value}월 임금을 전월 근무정보로 복사할까요?\n(이미 입력된 직원은 제외됩니다)\n\n※ 전월 지급 합계(기본급·수당 전액)는 그대로 복사됩니다.\n※ 요양보호사·조리는 방문요양과 같이 연·야·휴 비과세를 다시 나눕니다.\n※ 4대보험·공제는 당월 요율로 자동 계산되어 저장됩니다.`
    )
  ) {
    return;
  }
  bulkLoading.value = true;
  try {
    const res = await commonWageApi.copyFromPrev({
      mCode: memberCode.value,
      bizGubun: selectedBizGubun.value,
      year: selectedYear.value,
      month: selectedMonth.value,
    });
    if (!res.data?.success) throw new Error(res.data?.message || '전월 복사 실패');
    await loadWageList();
    const copiedCount = Number(res.data.copiedCount) || 0;
    const targets = wageRows.value.filter((row) => needsCopiedDeductionRecalc(row));
    let recalcNote = '';
    if (copiedCount > 0 && targets.length > 0 && effectiveTaxRateInfo.value) {
      const recalc = await bulkRecalcCopiedDeductions({
        rows: targets,
        mCode: memberCode.value,
        bizGubun: selectedBizGubun.value,
        year: selectedYear.value,
        month: selectedMonth.value,
        taxRateInfo: effectiveTaxRateInfo.value,
        incomeTaxTable: incomeTaxTable.value,
        minHourlyWage: effectiveTaxRateInfo.value.minHourlyWage,
        defaultWorkDays: defaultWorkDays.value,
      });
      await loadWageList();
      if (recalc.errorCount === 0) {
        recalcNote = `\n4대보험·공제 ${recalc.successCount}명 자동 계산 완료.`;
      } else {
        recalcNote = `\n4대보험 자동 계산: 성공 ${recalc.successCount}명, 실패 ${recalc.errorCount}명.`;
      }
    }
    alert((res.data.message || '복사되었습니다.') + recalcNote);
  } catch (error: any) {
    alert(`전월 복사 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    bulkLoading.value = false;
  }
};

const handleDeleteAllMonth = async () => {
  if (!memberCode.value) return;
  if (
    !confirm(
      `${selectedYear.value}년 ${selectedMonth.value}월 임금 데이터를 모두 삭제할까요?\n이 작업은 되돌릴 수 없습니다.`
    )
  ) {
    return;
  }
  bulkLoading.value = true;
  try {
    const res = await commonWageApi.deleteAllMonth({
      mCode: memberCode.value,
      bizGubun: selectedBizGubun.value,
      year: selectedYear.value,
      month: selectedMonth.value,
    });
    if (!res.data?.success) throw new Error(res.data?.message || '삭제 실패');
    alert(res.data.message || '삭제되었습니다.');
    showAllList();
    await loadWageList();
  } catch (error: any) {
    alert(`당월 삭제 실패: ${error.response?.data?.message || error.message}`);
  } finally {
    bulkLoading.value = false;
  }
};

watch(selectedBizGubun, () => {
  redirectIfHomeCare();
});

watch([selectedYear, selectedMonth], () => {
  syncUrlYearMonth();
});

watch(yearMonth, (ym, prev) => {
  if (prev && ym !== prev) {
    wageRows.value = [];
  }
});

watch([selectedYear, selectedMonth, selectedBizGubun, memberCode], (newVals, oldVals) => {
  if (isHomeCareBiz(selectedBizGubun.value)) return;

  const bizChanged = oldVals != null && newVals[2] !== oldVals[2];
  const memberChanged = oldVals != null && newVals[3] !== oldVals[3];
  if (bizChanged || memberChanged) {
    showAllList();
  }

  const preserveKey =
    !bizChanged && !memberChanged && mainView.value === 'detail' && selectedRow.value
      ? rowEmpKey(selectedRow.value)
      : null;

  void loadPageData(preserveKey);
});

onMounted(() => {
  const qYear = Number(route.query.year);
  const qMonth = Number(route.query.month);
  if (qYear >= 2000 && qYear <= 2100 && qMonth >= 1 && qMonth <= 12) {
    setYearMonth(qYear, qMonth);
  } else if (qYear >= 2000 && qYear <= 2100) {
    setYearMonth(qYear, selectedMonth.value);
  } else if (qMonth >= 1 && qMonth <= 12) {
    setYearMonth(selectedYear.value, qMonth);
  }
  syncUrlYearMonth();

  redirectIfHomeCare();
  if (!isHomeCareBiz(selectedBizGubun.value)) {
    loadPageData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wage-page home-wage-page", {
      'home-wage-page--member': !showTooltips.value,
      'home-wage-page--magam': _unref(isWageReadOnly),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "ym-nav-btn",
                disabled: listLoading.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMonth(-1)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(selectedYear)) + "." + _toDisplayString(String(_unref(selectedMonth)).padStart(2, '0')), 1),
                _createElementVNode("input", {
                  type: "month",
                  value: `${_unref(selectedYear)}-${String(_unref(selectedMonth)).padStart(2, '0')}`,
                  class: "hidden-month-picker",
                  "aria-label": `${_unref(selectedYear)}년 ${_unref(selectedMonth)}월 선택`,
                  disabled: listLoading.value,
                  onChange: onMonthPickerChange
                }, null, 40, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(LoadingOverlay, {
                  show: _unref(wageMagamLoading),
                  variant: "light"
                }, null, 8, ["show"]),
                (!_unref(wageMagamLoading))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(isWageMagamClosed))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "ym-magam-btn ym-magam-btn--done ym-magam-btn--clickable",
                            disabled: _unref(wageMagamReleasing),
                            title: "임금 마감 완료 — 클릭 시 마감 해제",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(releaseWageMagam) && _unref(releaseWageMagam)(...args)))
                          }, [
                            (_unref(wageMagamReleasing))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  size: "12",
                                  class: "mdi-spin"
                                }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("mdi-loading", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("마감완료")
                                ], 64))
                          ], 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "ym-magam-btn ym-magam-btn--ready",
                            disabled: _unref(wageMagamClosing) || listLoading.value,
                            title: magamReadyButtonTitle.value,
                            onClick: onCloseWageMagamClick
                          }, [
                            (_unref(wageMagamClosing))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  size: "12",
                                  class: "mdi-spin"
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-loading", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("마감하기")
                                ], 64))
                          ], 8, _hoisted_12))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ym-nav-btn",
                disabled: listLoading.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeMonth(1)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_13)
            ]),
            (!_unref(isWageMagamClosed) && !_unref(wageMagamLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("p", { class: "wage-magam-guide__text" }, " 이번 달 임금 작성이 끝나면 「마감하기」를 눌러 주세요. ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "setting-label" }, "지급일", -1)),
                _createVNode(YmdDateInput, {
                  modelValue: payDate.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payDate).value = $event)),
                  class: "setting-input",
                  disabled: listLoading.value || _unref(isWageMagamClosed) || savingMonthSettings.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "setting-label" }, "산재요율", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sanRateDisplay).value = $event)),
                    type: "text",
                    class: "setting-input setting-rate-input__field",
                    placeholder: "0.68",
                    inputmode: "decimal",
                    disabled: listLoading.value || _unref(isWageMagamClosed) || savingMonthSettings.value
                  }, null, 8, _hoisted_19), [
                    [_vModelText, sanRateDisplay.value]
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "setting-rate-input__suffix" }, "%", -1))
                ])
              ]),
              (!_unref(isWageMagamClosed))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "flat",
                    class: "btn-save sidebar-setting-save-btn",
                    size: "small",
                    block: "",
                    disabled: listLoading.value || savingMonthSettings.value,
                    onClick: handleSaveMonthSettings
                  }, {
                    default: _withCtx(() => [
                      (savingMonthSettings.value)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "14",
                            class: "mdi-spin"
                          }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("mdi-loading", -1)
                            ]))]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("저장")
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["home-wage-editable", { 'home-wage-editable--locked': _unref(isWageReadOnly) }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "sidebar-savings-btn",
                disabled: !memberCode.value,
                onClick: openNontaxSavings
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("mdi-piggy-bank-outline", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_21, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "sidebar-savings-btn__label" }, "인건비 절감", -1)),
                  (sidebarMonthSaving.value != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(formatNum(sidebarMonthSaving.value)) + "원 ", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "당월 절감액"))
                ])
              ], 8, _hoisted_20)
            ], 2),
            (mainView.value !== 'list')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn-show-all-list",
                  onClick: showAllList
                }, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                      _createTextVNode("mdi-format-list-bulleted", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[33] || (_cache[33] = _createTextVNode(" 사원전체목록보기 ", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "list-header-title" }, [
                _createElementVNode("span", { class: "list-header-dot" }),
                _createTextVNode(" 사원 목록 ")
              ], -1)),
              _createElementVNode("span", _hoisted_26, _toDisplayString(sortedEmployees.value.length) + "명", 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["sidebar-search-toggle", { 'sidebar-search-toggle--expanded': searchFiltersExpanded.value }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (searchFiltersExpanded.value = !searchFiltersExpanded.value))
              }, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "sidebar-search-toggle__label" }, "조건검색", -1)),
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(searchFiltersExpanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                  ]),
                  _: 1
                })
              ], 2),
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "search-label" }, "사원 검색", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchText).value = $event)),
                          type: "text",
                          placeholder: "이름...",
                          class: "search-input"
                        }, null, 512), [
                          [_vModelText, searchText.value]
                        ]),
                        (searchText.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "search-clear",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (searchText.value = ''))
                            }, [
                              _createVNode(_component_v_icon, { size: "10" }, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createTextVNode("mdi-close", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "search-label" }, "직종 필터", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filterJobType).value = $event)),
                        class: "search-select"
                      }, [
                        _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "전체", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobTypeOptions.value, (job) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: job,
                            value: job
                          }, _toDisplayString(job), 9, _hoisted_32))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, filterJobType.value]
                      ])
                    ])
                  ], 512), [
                    [_vShow, searchFiltersExpanded.value]
                  ])
                ]),
                _: 1
              })
            ]),
            (!listLoading.value && sortedEmployees.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[40] || (_cache[40] = [
                  _createElementVNode("span", null, "이름", -1),
                  _createElementVNode("span", null, "직종", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              (listLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "#1e3a5f",
                      size: "20",
                      width: "2"
                    })
                  ]))
                : (sortedEmployees.value.length === 0 && excludedEmployees.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, "등록된 사원이 없습니다."))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEmployees.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: _unref(rowEmpKey)(row),
                  class: _normalizeClass(["sidebar-emp-item", { active: isSelectedEmployee(row) }])
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "sidebar-emp-item__select",
                    disabled: listLoading.value || bulkLoading.value || removingEmployeeKey.value === _unref(rowEmpKey)(row),
                    onClick: ($event: any) => (selectEmployee(row))
                  }, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(row.ce_name), 1),
                      (row.cwhd_is_owner === 1 || isJoinMonth(row) || isLeaveMonth(row))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            (row.cwhd_is_owner === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, "대표"))
                              : _createCommentVNode("", true),
                            (isJoinMonth(row))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "입"))
                              : _createCommentVNode("", true),
                            (isLeaveMonth(row))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "퇴"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(row.ce_position || '-'), 1)
                  ], 8, _hoisted_37),
                  (canRemoveEmployeeFromList(row))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "sidebar-emp-item__remove",
                        title: "이번 달 사원 목록에서 제거",
                        disabled: listLoading.value || bulkLoading.value || _unref(isWageReadOnly) || !!removingEmployeeKey.value,
                        onClick: _withModifiers(($event: any) => (removeEmployeeFromList(row)), ["stop"])
                      }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ], 8, _hoisted_45))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              (excludedEmployees.value.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("p", _hoisted_46, "목록에서 제거됨 " + _toDisplayString(excludedEmployees.value.length) + "명", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excludedEmployees.value, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `ex-${_unref(rowEmpKey)(row)}`,
                        class: "sidebar-emp-item sidebar-emp-item--excluded"
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("span", _hoisted_49, _toDisplayString(row.ce_name), 1)
                          ]),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(row.ce_position || '-'), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sidebar-emp-item__restore",
                          title: "목록에 다시 넣기",
                          disabled: listLoading.value || bulkLoading.value || _unref(isWageReadOnly) || !!removingEmployeeKey.value,
                          onClick: _withModifiers(($event: any) => (restoreEmployeeToList(row)), ["stop"])
                        }, " 복원 ", 8, _hoisted_51)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (isAdmin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "sidebar-migration-block__note" }, "관리자 전용 · 엑셀 마이그레이션", -1)),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-refresh btn-migration",
                  size: "small",
                  block: "",
                  disabled: listLoading.value || bulkLoading.value,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showMigrationModal.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                        _createTextVNode("mdi-file-excel", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[43] || (_cache[43] = _createTextVNode(" 임금 엑셀 업로드 ", -1))
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-refresh btn-migration",
                  size: "small",
                  block: "",
                  disabled: listLoading.value || bulkLoading.value,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (showLedgerConvertModal.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-swap-horizontal", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createTextVNode(" 임금대장 치환(테스트) ", -1))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("button", {
              type: "button",
              class: "sidebar-labor-cost-btn sidebar-labor-cost-btn--above-tax",
              disabled: loadingLaborCostModal.value,
              onClick: openLaborCostModal
            }, [
              (loadingLaborCostModal.value)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    size: "14",
                    class: "mdi-spin"
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode("mdi-loading", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "14"
                  }, {
                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                      _createTextVNode("mdi-chart-pie", -1)
                    ]))]),
                    _: 1
                  })),
              _cache[49] || (_cache[49] = _createTextVNode(" 인건비지출내역 ", -1))
            ], 8, _hoisted_54),
            (taxRateInfo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["tax-info-toggle", { 'tax-info-toggle--expanded': taxRatePanelExpanded.value }]),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (taxRatePanelExpanded.value = !taxRatePanelExpanded.value))
                      }, [
                        _createElementVNode("span", _hoisted_58, "4대보험·세율 (" + _toDisplayString(taxRateInfo.value.year) + "년)", 1),
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(taxRatePanelExpanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                          ]),
                          _: 1
                        })
                      ], 2),
                      (canEditTaxRate.value && taxRatePanelExpanded.value)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "flat",
                            class: "btn-edit tax-info-edit-btn",
                            size: "x-small",
                            onClick: openTaxRateEditModal
                          }, {
                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                              _createTextVNode(" 수정 ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_59, [
                      (taxRateFallback.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, "※ 최근 연도 세율 적용"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRateDisplayRows.value, (taxRow) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: taxRow.label,
                          class: "tax-info-row"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(taxRow.label), 1),
                          _createElementVNode("span", null, _toDisplayString(taxRow.value), 1)
                        ]))
                      }), 128)),
                      (isAdmin.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _cache[52] || (_cache[52] = _createElementVNode("p", { class: "sidebar-wage-delete__admin-note" }, "관리자 전용 · 관리자만 표시됩니다", -1)),
                            _createElementVNode("p", _hoisted_62, _toDisplayString(_unref(selectedYear)) + "년 " + _toDisplayString(_unref(selectedMonth)) + "월 · 해당 연월 임금 데이터 전체 삭제 ", 1),
                            _createVNode(_component_v_btn, {
                              variant: "flat",
                              class: "btn-delete sidebar-wage-delete__btn",
                              size: "small",
                              block: "",
                              disabled: listLoading.value || bulkLoading.value || filteredRows.value.length === 0,
                              onClick: handleDeleteAllMonth
                            }, {
                              default: _withCtx(() => [
                                (bulkLoading.value)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      size: "14",
                                      class: "mdi-spin"
                                    }, {
                                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                        _createTextVNode("mdi-loading", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("당월 임금 전체삭제")
                                    ], 64))
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, taxRatePanelExpanded.value]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        (mainView.value === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createVNode(LoadingOverlay, {
                show: listLoading.value,
                text: "불러오는 중...",
                variant: "light"
              }, null, 8, ["show"]),
              _createVNode(LoadingOverlay, {
                show: bulkLoading.value,
                text: "처리 중...",
                variant: "light"
              }, null, 8, ["show"]),
              _createVNode(LoadingOverlay, {
                show: savingAll.value,
                text: `저장 중... (${savingAllProgress.value.current}/${savingAllProgress.value.total})`,
                variant: "save"
              }, null, 8, ["show", "text"]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#1e3a5f"
                    }, {
                      default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                        _createTextVNode("mdi-format-list-bulleted", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[54] || (_cache[54] = _createElementVNode("span", null, "사원별 급여 현황", -1))
                  ]),
                  _createElementVNode("span", _hoisted_68, _toDisplayString(sortedEmployees.value.length) + "명", 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(CommonWageReportMenu, {
                      "saved-wage-count": savedWageCount.value,
                      "employee-count": filteredRows.value.length,
                      "can-view-accounting-report": canViewAccountingReport.value,
                      "slip-disabled": savedWageCount.value === 0,
                      "is-admin": isAdmin.value,
                      "slip-label": "명세서 PDF",
                      onAccountingReport: downloadAccountingReport,
                      onClientReport: downloadClientReport,
                      onWageSlip: downloadWageSlip,
                      onNontaxMonthly: openNontaxCompare,
                      onNontaxYearly: openNontaxCompareYearly,
                      onTransaction: openTransactionModal
                    }, null, 8, ["saved-wage-count", "employee-count", "can-view-accounting-report", "slip-disabled", "is-admin"]),
                    _createVNode(WageSlipBroadcastButton, {
                      "is-closed": _unref(isWageMagamClosed),
                      "member-code": memberCode.value,
                      "year-month": yearMonth.value,
                      "biz-gubun": selectedBizGubun.value
                    }, null, 8, ["is-closed", "member-code", "year-month", "biz-gubun"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-refresh toolbar-import-btn",
                    size: "small",
                    disabled: listLoading.value || bulkLoading.value || _unref(isWageReadOnly),
                    onClick: handleCopyFromPrev
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                          _createTextVNode("mdi-content-copy", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[56] || (_cache[56] = _createTextVNode(" 전월복사 ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-save",
                    size: "small",
                    disabled: listLoading.value || bulkLoading.value || savingAll.value || filteredRows.value.length === 0 || _unref(isWageReadOnly),
                    onClick: saveAllData
                  }, {
                    default: _withCtx(() => [
                      (savingAll.value)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "14",
                            class: "mdi-spin"
                          }, {
                            default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                              _createTextVNode("mdi-loading", -1)
                            ]))]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("모두저장")
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("table", {
                  class: _normalizeClass(["home-wage-table", { 'home-wage-table--loading': listLoading.value }])
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[63] || (_cache[63] = _createElementVNode("th", { class: "col-no" }, "No", -1)),
                      _createElementVNode("th", {
                        class: "sortable col-name",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (toggleSort('name')))
                      }, [
                        _cache[58] || (_cache[58] = _createTextVNode(" 사원명 ", -1)),
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon('name')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", {
                        class: "sortable",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (toggleSort('job')))
                      }, [
                        _cache[59] || (_cache[59] = _createTextVNode(" 직종 ", -1)),
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon('job')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", {
                        class: "sortable col-wage",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (toggleSort('monthlyPay')))
                      }, [
                        _cache[60] || (_cache[60] = _createTextVNode(" 월급여 ", -1)),
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon('monthlyPay')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", {
                        class: "sortable col-wage",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (toggleSort('corpInsurance')))
                      }, [
                        _cache[61] || (_cache[61] = _createTextVNode(" 기관부담보험 ", -1)),
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon('corpInsurance')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", {
                        class: "sortable col-wage",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (toggleSort('retirement')))
                      }, [
                        _cache[62] || (_cache[62] = _createTextVNode(" 퇴직금 ", -1)),
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getSortIcon('retirement')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (sortedEmployees.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [...(_cache[64] || (_cache[64] = [
                          _createElementVNode("td", {
                            colspan: "6",
                            class: "empty-row"
                          }, "등록된 사원이 없습니다.", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEmployees.value, (row, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: _unref(rowEmpKey)(row),
                        class: _normalizeClass(["row-clickable", { 'row-selected': isSelectedEmployee(row) }]),
                        onClick: ($event: any) => (selectEmployee(row))
                      }, [
                        _createElementVNode("td", _hoisted_74, _toDisplayString(idx + 1), 1),
                        _createElementVNode("td", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", {
                              class: "avatar",
                              style: _normalizeStyle({ background: getAvatarColor(row.ce_name) })
                            }, _toDisplayString(getInitial(row.ce_name)), 5),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("span", _hoisted_78, _toDisplayString(row.ce_name), 1),
                              (row.cwhd_is_owner === 1 || isJoinMonth(row) || isLeaveMonth(row))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                    (row.cwhd_is_owner === 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_80, "대표"))
                                      : _createCommentVNode("", true),
                                    (isJoinMonth(row))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_81, "입"))
                                      : _createCommentVNode("", true),
                                    (isLeaveMonth(row))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_82, "퇴"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(row.ce_position || '-'), 1),
                        _createElementVNode("td", _hoisted_83, _toDisplayString(formatListWageAmount(row, 'monthlyPay')), 1),
                        _createElementVNode("td", _hoisted_84, _toDisplayString(formatListWageAmount(row, 'corpInsurance')), 1),
                        _createElementVNode("td", _hoisted_85, _toDisplayString(formatListWageAmount(row, 'retirement')), 1)
                      ], 10, _hoisted_73))
                    }), 128))
                  ])
                ], 2)
              ])
            ]))
          : (mainView.value === 'detail' && selectedRow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                _createVNode(LoadingOverlay, {
                  show: listLoading.value,
                  text: "불러오는 중...",
                  variant: "light"
                }, null, 8, ["show"]),
                _createVNode(LoadingOverlay, {
                  show: bulkLoading.value,
                  text: "처리 중...",
                  variant: "light"
                }, null, 8, ["show"]),
                _createVNode(LoadingOverlay, {
                  show: savingDetail.value,
                  text: "저장 중...",
                  variant: "save"
                }, null, 8, ["show"]),
                _createVNode(LoadingOverlay, {
                  show: importingPrevMonth.value,
                  text: "데이터 불러오는 중..."
                }, null, 8, ["show"]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "toolbar-back-btn",
                      onClick: showAllList
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                          _createTextVNode("mdi-arrow-left", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[66] || (_cache[66] = _createTextVNode(" 목록 ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "toolbar-emp-nav-btn",
                          disabled: !canNavigatePrevEmployee.value || isEmployeeNavDisabled.value,
                          "aria-label": "이전 사원",
                          onClick: navigatePrevEmployee
                        }, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                              _createTextVNode("mdi-chevron-left", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_91),
                        _createElementVNode("span", _hoisted_92, _toDisplayString(selectedRow.value.ce_name), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "toolbar-emp-nav-btn",
                          disabled: !canNavigateNextEmployee.value || isEmployeeNavDisabled.value,
                          "aria-label": "다음 사원",
                          onClick: navigateNextEmployee
                        }, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                              _createTextVNode("mdi-chevron-right", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_93)
                      ]),
                      _createElementVNode("span", _hoisted_94, _toDisplayString(selectedRow.value.ce_position || '-'), 1),
                      _createElementVNode("span", _hoisted_95, _toDisplayString(formatEmpTenureChip(selectedRow.value)), 1),
                      (formatEmpAgeChip(selectedRow.value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(formatEmpAgeChip(selectedRow.value)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createVNode(_component_v_btn, {
                        variant: "flat",
                        class: "btn-refresh",
                        size: "small",
                        disabled: !selectedRow.value.cwhd_idx,
                        onClick: downloadWageSlipForSelected
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                              _createTextVNode("mdi-file-pdf-box", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[70] || (_cache[70] = _createTextVNode(" 명세서 PDF ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-refresh toolbar-import-btn",
                      size: "small",
                      disabled: listLoading.value || bulkLoading.value || importingPrevMonth.value || savingDetail.value || _unref(isWageReadOnly),
                      onClick: importPrevMonthForSelected
                    }, {
                      default: _withCtx(() => [
                        (importingPrevMonth.value)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "14",
                              class: "mdi-spin"
                            }, {
                              default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                _createTextVNode("mdi-loading", -1)
                              ]))]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("지난달 데이터 가져오기")
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-save",
                      size: "small",
                      disabled: listLoading.value || bulkLoading.value || savingDetail.value || _unref(isWageReadOnly),
                      onClick: saveSelectedWage
                    }, {
                      default: _withCtx(() => [
                        (savingDetail.value)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "14",
                              class: "mdi-spin"
                            }, {
                              default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                                _createTextVNode("mdi-loading", -1)
                              ]))]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("저장")
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["detail-wage-board home-wage-editable", { 'home-wage-editable--locked': _unref(isWageReadOnly) }])
                }, [
                  (_openBlock(), _createBlock(CommonWageEditModal, {
                    key: `${_unref(rowEmpKey)(selectedRow.value)}-${_unref(selectedYear)}-${_unref(selectedMonth)}`,
                    ref_key: "wageEditModalRef",
                    ref: wageEditModalRef,
                    inline: "",
                    show: true,
                    row: selectedRow.value,
                    employees: sortedEmployees.value,
                    "m-code": memberCode.value,
                    year: _unref(selectedYear),
                    month: _unref(selectedMonth),
                    "biz-gubun": selectedBizGubun.value,
                    "min-hourly-wage": taxRateInfo.value?.minHourlyWage,
                    "tax-rate-info": effectiveTaxRateInfo.value,
                    "auto-calc-mode": autoCalcMode.value,
                    "basic-calc-mode-allowed": canUseBasicCalcMode.value,
                    "default-work-days": defaultWorkDays.value,
                    onSaved: onDetailSaved,
                    onDeleted: onDetailDeleted,
                    onChange: markDirty,
                    onHydrated: clearDirty
                  }, null, 8, ["row", "employees", "m-code", "year", "month", "biz-gubun", "min-hourly-wage", "tax-rate-info", "auto-calc-mode", "basic-calc-mode-allowed", "default-work-days"]))
                ], 2)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(CommonWageReportExcel, {
      ref_key: "wageReportRef",
      ref: wageReportRef,
      year: _unref(selectedYear),
      month: _unref(selectedMonth),
      "wage-data": savedWageRows.value,
      "member-name": _unref(memberData)?.value?.m_name || _unref(memberData)?.m_name,
      "tax-rate-info": effectiveTaxRateInfo.value,
      "income-tax-table": incomeTaxTable.value,
      "snapshot-only": wageMonthSnapshot.value,
      onError: onWageReportError
    }, null, 8, ["year", "month", "wage-data", "member-name", "tax-rate-info", "income-tax-table", "snapshot-only"]),
    _createVNode(CommonWageNontaxCompare, {
      ref_key: "nontaxCompareRef",
      ref: nontaxCompareRef,
      "wage-list": savedWageRows.value,
      "tax-rate": taxRate.value,
      "income-tax-table": incomeTaxTable.value,
      year: _unref(selectedYear),
      month: _unref(selectedMonth),
      "member-name": _unref(memberData)?.value?.m_name || _unref(memberData)?.m_name
    }, null, 8, ["wage-list", "tax-rate", "income-tax-table", "year", "month", "member-name"]),
    _createVNode(CommonWageNontaxCompareYearly, {
      ref_key: "nontaxCompareYearlyRef",
      ref: nontaxCompareYearlyRef,
      "m-code": memberCode.value,
      "member-name": _unref(memberData)?.value?.m_name || _unref(memberData)?.m_name,
      "biz-gubun": selectedBizGubun.value
    }, null, 8, ["m-code", "member-name", "biz-gubun"]),
    (isAdmin.value)
      ? (_openBlock(), _createBlock(CommonWageTransaction, {
          key: 0,
          ref_key: "transactionRef",
          ref: transactionRef,
          "m-code": memberCode.value,
          "member-name": memberDisplayName.value,
          "biz-gubun": selectedBizGubun.value,
          year: _unref(selectedYear),
          month: _unref(selectedMonth),
          "data-count": filteredRows.value.length
        }, null, 8, ["m-code", "member-name", "biz-gubun", "year", "month", "data-count"]))
      : _createCommentVNode("", true),
    (isAdmin.value)
      ? (_openBlock(), _createBlock(WageExcelMigrationModal, {
          key: 1,
          modelValue: showMigrationModal.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((showMigrationModal).value = $event)),
          "wage-type": "facility",
          "m-code": memberCode.value,
          "year-month": migrationYearMonth.value,
          "biz-gubun": selectedBizGubun.value,
          "pay-date": payDate.value || null,
          onImported: onMigrationImported
        }, null, 8, ["modelValue", "m-code", "year-month", "biz-gubun", "pay-date"]))
      : _createCommentVNode("", true),
    (isAdmin.value)
      ? (_openBlock(), _createBlock(WageLedgerConvertModal, {
          key: 2,
          modelValue: showLedgerConvertModal.value,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showLedgerConvertModal).value = $event)),
          "wage-type": "facility"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(WageSsnMissingModal, {
      modelValue: ssnMissingModalOpen.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((ssnMissingModalOpen).value = $event)),
      "member-code": memberCode.value,
      "year-month": yearMonth.value,
      onSaved: onSsnMissingSaved,
      onContinueMagam: onSsnMissingContinueMagam
    }, null, 8, ["modelValue", "member-code", "year-month"]),
    _createVNode(CommonWageLaborCostModal, {
      ref_key: "laborCostModalRef",
      ref: laborCostModalRef,
      "member-code": memberCode.value,
      year: _unref(selectedYear),
      month: _unref(selectedMonth),
      "biz-gubun": selectedBizGubun.value
    }, null, 8, ["member-code", "year", "month", "biz-gubun"]),
    _createVNode(_component_v_dialog, {
      modelValue: showTaxRateEditModal.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showTaxRateEditModal).value = $event)),
      "max-width": "360",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_99, [
          _createVNode(LoadingOverlay, {
            show: savingTaxRate.value,
            text: "저장 중...",
            variant: "save"
          }, null, 8, ["show"]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("span", _hoisted_101, "세율 수정 (" + _toDisplayString(taxRateEditTargetYear.value) + "년)", 1),
            _cache[74] || (_cache[74] = _createElementVNode("span", { class: "admin-only-chip" }, "관리자전용", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "home-wage-tax-rate-edit-dialog__close",
              disabled: savingTaxRate.value,
              "aria-label": "닫기",
              onClick: closeTaxRateEditModal
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_102)
          ]),
          _createElementVNode("div", _hoisted_103, [
            (taxRateFallback.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(taxRateInfo.value?.year) + "년 세율이 표시 중입니다. 저장하면 " + _toDisplayString(taxRateEditTargetYear.value) + "년 세율이 생성됩니다. ", 1))
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(taxRateEditFields, (field) => {
              return _createElementVNode("div", {
                key: field.key,
                class: "edit-field"
              }, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(field.label), 1),
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((taxRateEditForm.value[field.key]) = $event),
                    type: "text",
                    class: "edit-input",
                    inputmode: field.isLaborRate ? 'decimal' : 'decimal',
                    onBlur: ($event: any) => (onTaxRateEditBlur(field.key))
                  }, null, 40, _hoisted_107), [
                    [_vModelText, taxRateEditForm.value[field.key]]
                  ]),
                  (field.unit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_108, _toDisplayString(field.unit), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createVNode(_component_v_btn, {
              variant: "text",
              class: "btn-cancel",
              disabled: savingTaxRate.value,
              onClick: closeTaxRateEditModal
            }, {
              default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                _createTextVNode(" 취소 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-save",
              disabled: savingTaxRate.value,
              onClick: saveTaxRateEdit
            }, {
              default: _withCtx(() => [
                (savingTaxRate.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      size: "14",
                      class: "mdi-spin"
                    }, {
                      default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                        _createTextVNode("mdi-loading", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _cache[77] || (_cache[77] = _createTextVNode(" 저장 ", -1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})